import apiService from '../util/request.js';

/** module that contains api functions that deal with contact request messages and threads
 * @module conversationApiService */

/** fetch conversation threads by location id
 * @param {String} params.locationId location id
 * @returns {AxiosPromise<any>}
 */
const getRequests = params => {
  return apiService.get('/messages/thread', { params });
};

/** fetch conversation thread by access token
 * @param {String} accessToken token of a thread
 * @returns {AxiosPromise<any>}
 */
const getThreadDetail = accessToken => {
  return apiService.get(`/messages/thread/${accessToken}`);
};

/** fetch threads for a location
 * @returns {AxiosPromise<any>}
 */
const findThread = params => {
  return apiService.get('/messages/thread', { params });
};

/** fetch messages from a thread by thread access token
 * @param {String} accessToken token of a thread
 * @returns {AxiosPromise<any>}
 */
const getThreadMessages = accesstoken => {
  return apiService.get(`/messages/thread/${accesstoken}/message`);
};

/** post a message to a thread
 * @param {String} payload.accessToken thread token
 * @param {String} payload.message message to post
 * @returns {AxiosPromise<any>}
 */
const postMessage = (payload) => {
  return apiService.post(`/messages/thread/${payload.accessToken}/message`, payload.message);
};

/** create a new thread
 * @param {String} payload.attrs.type type of a thread
 * @param {String | null} payload.attrs.offerSearchKey offerSearchKey (what you get if you search for offers)
 * @param {String | null} payload.bookedOfferKey offer key of an offer
 * @param {String} payload.contactRequestText text of a message to add to the thread
 * @param {String} payload.source.applicationSource type of source (which app created the thread)
 * @param {String} payload.source.dataSource 'CONTACT_REQUEST'
 * @param {String} payload.userInfo.email form data of a new lead - email
 * @param {String} payload.userInfo.firstName form data of a new lead - firstName
 * @param {String} payload.userInfo.lastName form data of a new lead - lastName
 * @param {String} payload.userInfo.phone form data of a new lead - phone
 * @param {String} payload.vehicleId id of a selected vehicle
 * @param {String | null} payload.offerKey offer key of an offer
 * @returns {AxiosPromise<any>}
 */
const postThread = (payload) => {
  return apiService.post('/service-case/case/contact-request', payload);
};

export default {
  getRequests,
  getThreadDetail,
  getThreadMessages,
  postMessage,
  postThread,
  findThread
}
